// Called from inline `onblur` handlers (form_builder _birthday.hbs), so it
// must be a window global.
window.checkIfPastDate = function checkIfPastDate(objectElem) {
  var selectedDate = new Date(objectElem.value);
  var now = new Date();
  if (selectedDate > now) {
    objectElem.setCustomValidity("Invalid birthdate: Date must be in the past");
  } else {
    objectElem.setCustomValidity("");
  }
};
